import React from 'react';
import FieldsForm from '../FieldsForm/FieldsForm';

import { Form, Row, Col, Spin, Button, GreenButton } from 'clad';

class CustomizedModalForm extends React.Component {
    constructor(props) {
        super(props);
        const getThis = () => this;

        this.WrappedFieldsForm = Form.create({
            onValuesChange(props, values, allValues) {
                const parent = getThis();
                parent.setState({ saved: false, changed: true });
                if (props.onChange) {
                    props.onChange(props, values, allValues);
                }
            }
        })(FieldsForm);

        this.state = {
            saved: false,
            changed: false,
            saving: false,
            firstTimeSaved: false
        };
    }

    handleClose = () => {
        const { onCancel, onClose } = this.props;

        if (onClose) {
            onClose();
        } else {
            if (onCancel) {
                onCancel();
            }
        }
    };

    handleCancel = () => {
        const { onCancel } = this.props;
        const { form } = this.formRef.props;

        if (onCancel) {
            onCancel();
        }
        form.resetFields();
    };

    handleSave = () => {
        const { onSave, onRefresh, record } = this.props;
        const { form } = this.formRef.props;

        let action = 'create';

        if (Object.keys(record).length) {
            action = 'edit';
        }

        form.validateFields(async (err, values) => {
            try {
                if (err) {
                    return;
                }

                this.setState({ saving: true });
                await onSave(values);
                if (onRefresh) onRefresh();

                if (action === 'create') this.handleClose();
                this.setState({
                    saving: false,
                    saved: true,
                    changed: false,
                    firstTimeSaved: true
                });
            } catch (err) {
                this.setState({
                    saving: false,
                    saved: false,
                    changed: false
                });
            }
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { title, record } = this.props;
        const { saved, firstTimeSaved } = this.state;

        const prevId = prevProps.record && prevProps.record.id;
        const newId = record && record.id;
        if (prevId !== newId) {
            if (this.formRef) {
                const { form } = this.formRef.props;
                form.resetFields();
            }
            this.setState({ saved: false, changed: false, firstTimeSaved: false });
        }

        if (!saved && firstTimeSaved) {
            let elements = document.getElementsByClassName('ant-modal-title');
            if (elements.length > 0) {
                elements[0].innerHTML = title.edit;
            }
        }
    }

    render() {
        const { fields, record, loading, onChange } = this.props;
        const { WrappedFieldsForm } = this;

        const actions = () => {
            return (this.state.saved && !this.state.changed) ||
                (!this.state.saved &&
                    !this.state.changed &&
                    Object.keys(record).length) ? (
                <Button key="close" onClick={this.handleClose}>
                    {_('Close')}
                </Button>
            ) : (
                <React.Fragment>
                    <Button key="cancel" onClick={this.handleCancel}>
                        {_('Cancel')}
                    </Button>
                    <GreenButton
                        key="save"
                        style={{ marginLeft: 8 }}
                        disabled={this.state.saved}
                        onClick={this.handleSave}
                    >
                        {_('Save')}
                    </GreenButton>
                </React.Fragment>
            );
        };

        const mask = Boolean(this.state.saving || loading);
        const maskMessage = loading ? _('Loading data') : _('Saving data...');

        return (
            <Spin spinning={mask} tip={maskMessage}>
                <WrappedFieldsForm
                    wrappedComponentRef={el => (this.formRef = el)}
                    fields={fields}
                    record={record}
                    onChange={onChange}
                />
                <Row>
                    <Col span={24} style={{ textAlign: 'right' }}>
                        {actions()}
                    </Col>
                </Row>
            </Spin>
        );
    }
}

export default CustomizedModalForm;
